/* eslint-disable @typescript-eslint/indent */
import React from 'react';
import DropDownIconMenu from 'components/shared/form/drop_down_icon_menu';
import { MenuItemType } from 'utility/enumerations';
import { useHistory } from 'react-router-dom';
// @ts-ignore
import styles from './site.module.scss';
import { globalEndpoints } from '../../../endpoints/global';

interface UserMenuProps {
   menuItems: any,
   // eslint-disable-next-line react/no-unused-prop-types
   animationPlaybackEvent: any,
   // eslint-disable-next-line react/no-unused-prop-types
   dropdownId: number,
   // eslint-disable-next-line react/no-unused-prop-types
   history: any
}

export const UserMenu = (props: UserMenuProps) => {
  const history = useHistory();

  const handleSelect = (item) => {
    if (item && item.type === MenuItemType.Navigation && item.route) {
      if (item.route.startsWith('api/')) {
        window.location.href = `${globalEndpoints.apiUrl}${item.route.replace('api', '')}`;
      } else {
        history.push(item.route);
      }
    }
  };

  return props.menuItems ? (
    <div className={styles.userMenu}>
      <DropDownIconMenu
        id={0}
        items={props.menuItems}
        onSelect={handleSelect}
        toggleClassName="btn-circle"
        icon="user"
        variant="primary"
      />
    </div>
  ) : null;
};
